/**
 * Shared-view counterpart of ProjectStateAdapterBridge.
 * Sets the projectStateAdapter so that AssetsProvider can load assets via AssetManager
 * when there is no ProjectState in the component tree (public shared view route).
 *
 * Only shared-view-page.tsx should import from this file.
 */

import { setProjectSnapshot } from '../../state/project-state/adapter/project-state-adapter.internal';
import type { ProjectSnapshot } from '../../state/project-state/project-state-adapter';

const EMPTY: ProjectSnapshot = Object.freeze({
  status: 'idle',
  projectId: null,
  project: null,
  source: 'unknown',
});

export function setSharedViewProjectId(projectId: string): void {
  setProjectSnapshot({
    status: 'ready',
    projectId,
    project: null,
    source: 'shared-view',
  });
}

export function clearSharedViewProjectId(): void {
  setProjectSnapshot(EMPTY);
}
